"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: referral/referral-code-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Freferral%2Freferral-code-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.referralCodeStatusToJSON = exports.referralCodeStatusFromJSON = exports.ReferralCodeStatus = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.referral.proto';
var ReferralCodeStatus;
(function (ReferralCodeStatus) {
    ReferralCodeStatus["INVALID_REFERRAL_CODE_STATUS"] = "INVALID_REFERRAL_CODE_STATUS";
    /**
     * ACTIVE - Referral code can be redeemed as normal
     */
    ReferralCodeStatus["ACTIVE"] = "ACTIVE";
    /**
     * DISABLED_REFERRER_REWARD - The referral code can be redeemed and the redeemer will get a reward but
     * there will be no reward for the referrer
     */
    ReferralCodeStatus["DISABLED_REFERRER_REWARD"] = "DISABLED_REFERRER_REWARD";
    /**
     * BLOCKED - The referral code is blocked and any attempt to redeem will return an
     * error
     */
    ReferralCodeStatus["BLOCKED"] = "BLOCKED";
    ReferralCodeStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ReferralCodeStatus || (exports.ReferralCodeStatus = ReferralCodeStatus = {}));
function referralCodeStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REFERRAL_CODE_STATUS':
            return ReferralCodeStatus.INVALID_REFERRAL_CODE_STATUS;
        case 1:
        case 'ACTIVE':
            return ReferralCodeStatus.ACTIVE;
        case 2:
        case 'DISABLED_REFERRER_REWARD':
            return ReferralCodeStatus.DISABLED_REFERRER_REWARD;
        case 3:
        case 'BLOCKED':
            return ReferralCodeStatus.BLOCKED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ReferralCodeStatus.UNRECOGNIZED;
    }
}
exports.referralCodeStatusFromJSON = referralCodeStatusFromJSON;
function referralCodeStatusToJSON(object) {
    switch (object) {
        case ReferralCodeStatus.INVALID_REFERRAL_CODE_STATUS:
            return 'INVALID_REFERRAL_CODE_STATUS';
        case ReferralCodeStatus.ACTIVE:
            return 'ACTIVE';
        case ReferralCodeStatus.DISABLED_REFERRER_REWARD:
            return 'DISABLED_REFERRER_REWARD';
        case ReferralCodeStatus.BLOCKED:
            return 'BLOCKED';
        case ReferralCodeStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.referralCodeStatusToJSON = referralCodeStatusToJSON;
//# sourceMappingURL=referral-code-status.js.map